import { render } from "./waiting-for-link.vue?vue&type=template&id=1f6d2168"
import script from "./waiting-for-link.vue?vue&type=script&lang=js"
export * from "./waiting-for-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__